import {
	getController,
	apiService as Service,
	type HpRequestOptional,
} from '@/services/service'

const url = 'handoverprotocols'

export const handoverProtocolService = {
	...getController<
		Api.HandoverProtocol,
		Api.HandoverProtocolPostInput,
		Api.HandoverProtocolUpdatedInput
	>(url),
	signeesPending: (id: number, data?: HpRequestOptional) =>
		Service.get({ url: `${url}/${id}/signees_pending`, ...data }),
	generateProtocol: (data?: HpRequestOptional) =>
		Service.post({ url: `${url}/generate`, ...data }),
}
